import { Button, Card, Table, TableProps } from 'antd'
import { VestingData } from 'Modules'

import LinkAddress from 'component/link/link-address'
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'constants/pagination'
import { useVestingData } from 'hooks/vesting/use-vesting-data'

const VestingHistory = () => {
  const { loading, data, total, searchParams, getData, handleTableChange, onChangeSearchParams } =
    useVestingData({ includeDataContract: true })

  const { page, limit, ownerAddress } = searchParams || {}

  // Define table columns
  const columns: TableProps<VestingData>['columns'] = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => {
        return (
          (Number(page || DEFAULT_PAGE_INDEX) - 1) * Number(limit || DEFAULT_PAGE_SIZE) + index + 1
        )
      },
      width: 70,
      align: 'center',
    },
    {
      title: 'User Address',
      dataIndex: 'ownerAddress',
      key: 'ownerAddress',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <LinkAddress address={text} max={0} />
        </div>
      ),
    },
    {
      title: 'Total Token (MEY)',
      dataIndex: 'amountContract',
      key: 'amountContract',
      render: (text, record) => {
        return <span>{new Intl.NumberFormat('en-US').format(record?.amountContract || 0)}</span>
      },
    },
    {
      title: 'Claimed (MEY)',
      dataIndex: 'ownerAddress',
      key: 'ownerAddress',
      render: (text, record) => {
        return <span>{new Intl.NumberFormat('en-US').format(record?.claimed || 0)}</span>
      },
    },
    {
      title: 'Locked (MEY)',
      dataIndex: 'ownerAddress',
      key: 'ownerAddress',
      render: (text, record) => {
        return <span>{new Intl.NumberFormat('en-US').format(record?.totalLocked || 0)}</span>
      },
    },
    {
      title: 'Unlocked (MEY)',
      dataIndex: 'ownerAddress',
      key: 'ownerAddress',
      render: (text, record) => {
        return <span>{new Intl.NumberFormat('en-US').format(record?.unlock || 0)}</span>
      },
    },
  ]

  return (
    <>
      <div className="main-title" style={{ marginBottom: 20 }}>
        Vesting claim
      </div>
      <div className="user-search">
        <input
          type="text"
          placeholder="Address"
          value={ownerAddress}
          onChange={(e) => {
            onChangeSearchParams({
              ownerAddress: e.target.value,
              page: DEFAULT_PAGE_INDEX,
            })
          }}
        />
        <Button type="primary" onClick={() => getData(searchParams)}>
          Search
        </Button>
      </div>
      <Card style={{ margin: '0 auto' }}>
        <Table<VestingData>
          rowKey="_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={total < 11 ? false : { total: total, current: page, pageSize: limit }}
          onChange={handleTableChange}
          scroll={{ x: 1000 }}
          bordered
        />
      </Card>
    </>
  )
}

export default VestingHistory
